import * as React from 'react'

import { getConfigBySite } from '../../../config/sites'
import createAutoSuggestDataContainer from '../../components/autosuggest/autoSuggestDataContainer'
import createAutoSuggestLogicContainer from '../../components/autosuggest/autoSuggestLogicContainer'
import SearchHeader from '../../components/searchHeader'
import SeoHeadings from '../../components/seoHeadings/seoHeadings'
import AutoSuggest from '../../v0/components/autosuggest/autosuggest'
import CommunitySection from './communitySection'
import FeaturedAuthorSection from './featuredAuthorSection'
import FeaturedItemsSection from './featuredItemsSection'
import FreeItemSection from './freeItemSection'
import MarketingSection from './marketingSection'
import NewestItemSection from './newestItemSection'
import PageSection from './pageSection'
import TutorialsSection from './tutorialsSection'
import ExperimentsLoadingCover from '../../components/experimentsLoadingCover'
import experimentsConfig from '../../../config/experiments'
import FeatureContainer from '../../containers/feature'
import VerticalDivider from '../../components/verticalDivider/verticalDivider'
import SearchLink from '../../containers/searchLinkContainer'
import PromoBox from '../../components/promoBox/promoBox'
import copyData from './homePageCopyData'
import SectionDescription from './sectionDescription'

import * as searchHeaderStylesElementsBanner from '../../components/searchHeader/themes/homepage.elementsbanner.module.css'
import * as searchHeaderStyles from '../../components/searchHeader/themes/homepage.module.css'
import * as seoHeadingsStyles from '../../components/seoHeadings/themes/homepage.module.css'
import * as seoHeadingsStylesElementsBanner from '../../components/seoHeadings/themes/homepage.elementsbanner.module.css'
import * as autoSuggestStyles from '../../v0/components/autosuggest/themes/homepage.module.css'
import * as autoSuggestStylesElementsBanner from '../../v0/components/autosuggest/themes/homepage.elementsbanner.module.css'
import * as styles from './homePage.module.css'

import { Props } from '../../containers/homePageContainer/createHomePageContainer'

const AutoSuggestContainer = createAutoSuggestDataContainer(
  createAutoSuggestLogicContainer(AutoSuggest)
)

const HomePage = ({
  currentSite,
  isSignedIn,
  metadata,
  categories,
  newestItemsData,
  featuredItems,
  freeItems,
  featuredAuthor,
  fetchNewestItemsByCategory,
  preferences,
  muteVideo,
  reportItemClick,
  makeSearchLink,
  experimentsReady
}: Props) => {
  const siteCopyData = copyData[currentSite] || copyData.default
  return (
    <div className={styles.root}>
      <ExperimentsLoadingCover
        currentSite={currentSite}
        experimentsReady={experimentsReady}
        experimentsConfig={experimentsConfig}
      >
        <div className={styles.searchHeaderSection}>
          <FeatureContainer name="!homePageElementsBanner">
            <SearchHeader currentSite={currentSite} styles={searchHeaderStyles}>
              {metadata && (
                <SeoHeadings
                  TagName="h1"
                  heading={metadata.search_area.heading}
                  subHeading={metadata.search_area.sub_heading || ''}
                  styles={seoHeadingsStyles}
                />
              )}
              <AutoSuggestContainer
                inputName="term"
                value=""
                placeholder={getConfigBySite(
                  currentSite,
                  'home_search_placeholder'
                )}
                currentSite={currentSite}
                locationParams={{}}
                makeSearchLink={makeSearchLink}
                styles={autoSuggestStyles}
                showCategories={true}
              />
            </SearchHeader>
          </FeatureContainer>
          <FeatureContainer name="homePageElementsBanner">
            <SearchHeader
              currentSite={currentSite}
              styles={searchHeaderStylesElementsBanner}
            >
              <div className={styles.elementsBannerSearchArea}>
                {metadata && (
                  <SeoHeadings
                    TagName="h1"
                    heading={metadata.search_area.heading}
                    subHeading={metadata.search_area.sub_heading || ''}
                    styles={seoHeadingsStylesElementsBanner}
                  />
                )}
                <AutoSuggestContainer
                  inputName="term"
                  value=""
                  placeholder={getConfigBySite(
                    currentSite,
                    'home_search_placeholder'
                  )}
                  currentSite={currentSite}
                  locationParams={{}}
                  makeSearchLink={makeSearchLink}
                  styles={autoSuggestStylesElementsBanner}
                  showCategories={true}
                />
                <ul className={styles.elementsBannerList}>
                  {siteCopyData.marketPromoList &&
                    siteCopyData.marketPromoList.map((value: any, key: any) => (
                      <li key={key}>{value}</li>
                    ))}
                </ul>
              </div>
              <VerticalDivider
                currentSite={currentSite}
                label="OR"
                className={styles.elementsBannerDivider}
              />
              <div>
                <PromoBox
                  slim
                  title={siteCopyData.elementsPromoTitle}
                  logo="images/logo-envato-elements-white.svg"
                  content={siteCopyData.elementsPromoList}
                >
                  <FeatureContainer name="!homePageElementsBannerAltCTA">
                    <a
                      className={`${styles.promoButton} ${
                        styles.promoButtonElements
                      }`}
                      href={`https://elements.envato.com/all-items?utm_campaign=elements_mkt-homepagetest_20200228&utm_content=h1_banner&utm_medium=referral&utm_source=${currentSite}.net`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Go to Envato Elements
                    </a>
                  </FeatureContainer>
                  <FeatureContainer name="homePageElementsBannerAltCTA">
                    <a
                      className={`${styles.promoButton} ${
                        styles.promoButtonElements
                      }`}
                      href={`https://elements.envato.com/?utm_campaign=elements_mkt-homepagetest_20200228&utm_content=h1_banner&utm_medium=referral&utm_source=${currentSite}.net`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Go to Envato Elements
                    </a>
                  </FeatureContainer>
                </PromoBox>
              </div>
            </SearchHeader>
          </FeatureContainer>
          <FeatureContainer name="homePageEnvatoProductsBanner">
            <PageSection
              darkBackground
              spaceTop
              sectionId="elements-promo-section"
            >
              <SectionDescription
                metadata={{ heading: 'Which Envato product is right for you?' }}
                HTag="h3"
              />
              <div className={styles.homePageEnvatoProductsBannerContent}>
                <PromoBox
                  title={siteCopyData.marketPromoTitle}
                  logo="images/logo-envato-market.svg"
                  content={siteCopyData.marketPromoList}
                >
                  <SearchLink
                    className={`${styles.promoButton} ${
                      styles.promoButtonMarket
                    }`}
                    locationParams={{}}
                  >
                    {siteCopyData.marketPromoButtonLabel}
                  </SearchLink>
                </PromoBox>
                <PromoBox
                  title={siteCopyData.elementsPromoTitle}
                  logo="images/logo-envato-elements-white.svg"
                  content={siteCopyData.elementsPromoList}
                >
                  <a
                    className={`${styles.promoButton} ${
                      styles.promoButtonElements
                    }`}
                    href={`https://elements.envato.com/all-items?utm_campaign=elements_mkt-homepagetest_20200228&utm_content=h1_banner&utm_medium=referral&utm_source=${currentSite}.net`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Go to Envato Elements
                  </a>
                </PromoBox>
              </div>
            </PageSection>
          </FeatureContainer>
        </div>

        {metadata && (
          <FeaturedItemsSection
            name="Homepage: Featured items"
            items={featuredItems.slice(0, 10)}
            metadata={metadata.featured_items}
            muteVideo={muteVideo}
            videoMuted={preferences.searchVideoMuted}
            reportItemClick={reportItemClick}
            currentSite={currentSite}
          />
        )}

        {newestItemsData.items && metadata && (
          <PageSection sectionId="newest-item-section">
            <NewestItemSection
              categories={categories}
              name="Homepage: New items"
              currentSite={currentSite}
              fetchNewestItemsByCategory={fetchNewestItemsByCategory}
              metadata={metadata.newest_items}
              newestItemsData={newestItemsData}
              muteVideo={muteVideo}
              videoMuted={preferences.searchVideoMuted}
              reportItemClick={reportItemClick}
              hideCategories={getConfigBySite(currentSite, 'hide_categories')}
              nonSquare={
                !getConfigBySite(currentSite, 'homepage.newest_items_square')
              }
            />
          </PageSection>
        )}

        {metadata && (
          <PageSection sectionId="free-item-section" borderTop>
            <FreeItemSection
              currentSite={currentSite}
              name="Homepage: Free files of the month"
              isSignedIn={isSignedIn}
              items={freeItems}
              metadata={metadata.free_items}
              muteVideo={muteVideo}
              videoMuted={preferences.searchVideoMuted}
              reportItemClick={reportItemClick}
            />
          </PageSection>
        )}

        {metadata && <MarketingSection blocks={metadata.marketing_blocks} />}

        {metadata && (
          <PageSection sectionId="featured-author-section" borderTop>
            <FeaturedAuthorSection
              currentSite={currentSite}
              name="Homepage: Featured authors"
              items={featuredAuthor.matches}
              author={featuredAuthor.author}
              metadata={metadata.featured_author}
              muteVideo={muteVideo}
              videoMuted={preferences.searchVideoMuted}
              reportItemClick={reportItemClick}
            />
          </PageSection>
        )}

        {metadata && <CommunitySection metadata={metadata.community} />}

        {metadata && (
          <PageSection sectionId="tutorial-section">
            <TutorialsSection metadata={metadata.tutorials} />
          </PageSection>
        )}
      </ExperimentsLoadingCover>
    </div>
  )
}

export default HomePage
